import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";

export const useGetAllPaymentModeService = ({
  enableQuery = true,
  page = "1",
  per_page = "15",
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);

  const getAllPaymentModeService = useQuery({
    queryKey: [
      ...CACHE_KEYS.PAYMENT_MASTER,
      ...CACHE_KEYS.PAYMENT_MODE,
      page,
      debouncedQuery,
      per_page,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.PAYMENT_MODE,
        searchParams: {
          "filter[name]": debouncedQuery,
          page,
          per_page,
        },
      }),
    enabled: enableQuery,
  });
  return {
    services: { getAllPaymentModeService },
    states: { setSearchQuery, searchQuery },
  };
};
